$(function(){
    console.log('Jumpstart Scripts');
    initflickityCarouselGallerycomparison();
    initFlickityFeaturedCollection();
    handleCollectionTabClick();
    gridflickityproductTabs();
    replacenoscriptimgglossary();
    navigationglossary();
    opencloseaccordionglossaryonload();
    pdpDescReadMore();
    getCardInformationMaxHeight();
    cartJsEvent();
    setTimeout(function(){
        cartDrawerUpt();
    },500);
    if (location.href.includes('/cart')) {
        masterPromo();
    }
});

$(window).on('resize', function() {
    getCardInformationMaxHeight();
    try {
        destroyFlickityFeaturedCollection();
        initFlickityFeaturedCollection();
    } catch (error) {
        console.log('Error in resize handler:', error);
    }
});

// Start - cartjs general function
cartJsEvent = () =>{
    $(document).on('cart.requestStarted', function(event, cart) {
        $('.jsc-page-loading').show();
    });
    $(document).on('cart.requestComplete', function(event, cart) {
        $('.jsc-page-loading').hide();
    });
}

cartDrawerUpt = () => {
    $(document).on('cart.requestComplete', function(event, cart) {
        if (location.href.includes('/cart')) {
        location.reload();
        }else {
        fetch("?section_id=mini-cart")
        .then(response => response.text())
        .then(html => {
            document.getElementById('mini-cart').innerHTML =
            getThis.getSectionInnerHTML(html, '.shopify-section');
            getThis.open();
        })
        .catch(e => {
            console.error(e);
        });

        fetch("?section_id=cart-icon-bubble")
        .then(response => response.text())
        .then(html => {
            console.log(getThis);
            document.getElementById('cart-icon-bubble').innerHTML =
            getThis.getSectionInnerHTML(html, '.shopify-section');
            getThis.open();
        })
        .catch(e => {
            console.error(e);
        });

        }
    });
}
cartJSAddQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.addItem(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: isOpenDrawer,
                detail: {
                variant: vid,
                quantity: qty
                }
            }));
            */
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });
}

cartJSUpdateQuery = (vid, qty, obj, isOpenDrawer) => {
    // Cart js add item, success callback, error callback

    CartJS.updateItemById(vid, qty, obj,
    {
        // Define a success callback to display a success message.
        "success": function(data, textStatus, jqXHR) {
        $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            beforeSend: function() {
            console.log('before');
            },
            success: function(cart) {
            /*
            getThis.element.dispatchEvent(new CustomEvent('product:added', {
                bubbles: isOpenDrawer,
                detail: {
                variant: vid,
                quantity: qty
                }
            }));
            */
            }
        });
        },
        // Define an error callback to display an error message.
        "error": function(jqXHR, textStatus, errorThrown) {
        console.log("Error occur !", errorThrown);
        }
    });
}
// End - cartjs general function
// Start - onload and onclick all promo
masterPromo = (isDrawer) =>{
    console.log('masterPromo');

    setTimeout(function(){
        gwpFunction(isDrawer);
        cartGift();
    },100);

}
// End - onload and onclick all promo
// Start - Simple GWP promo
gwpFunction = (isOpenDrawer) =>{
    $.when($.getJSON('/cart.js', function(cart) {

    })).then(function(cart){
        var $gwpcart_product = {};
        var $addEle = $('.jsc-add-gwp');
        var $updateEle = $('.jsc-update-gwp');
        var $deleteEle = $('.jsc-remove-gwp');

        $gwpcart_product['_Promo'] = 'Free Gift';

        $addEle.each(function() {
        var $vid = parseInt($(this).val());
        var $qty = parseInt($(this).attr('data-qty'));

        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

        cartJSAddQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $updateEle.each(function() {
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));

        $gwpcart_product['_Promo_no'] = $(this).attr('data-promo');

        cartJSUpdateQuery($vid, $qty, $gwpcart_product, isOpenDrawer);
        });

        $deleteEle.each(function() {
        var $vid = $(this).val();
        var $qty = 0;

        cartJSUpdateQuery($vid, $qty, {}, isOpenDrawer);
        });

    });
}
// End - Simple GWP promo
//Start GWP based on cart, product or collection promo
cartGift = () =>{
    addCartGift();
    removeCartGift();
}
  
addCartGift = () =>{
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift');
    $elem.each(function(){
    $loader.show();
    var $vid = parseInt($(this).val());
    var $obj = {};
    var $promoNo = $(this).attr('data-promo');

    $obj['_Cart_Gift'] = $promoNo;
    $obj['_Cart_GWP'] = 'Free Gift';
    if ($elem.length > 0) {
        cartJSAddQuery($vid,1,$obj,true);
    }
    });
    $('.jsc-cart-gift-upt').each(function () {
        $loader.show();
        var $vid = $(this).val();
        var $qty = parseInt($(this).attr('data-qty'));

        var $obj = {};
        var $promoNo = $(this).attr('data-promo');
        $obj['_Cart_Gift'] = $promoNo;
        $obj['_Cart_GWP'] = 'Free Gift';

        cartJSUpdateQuery($vid, $qty, $obj, false);
    });
}

removeCartGift = () =>{
    var $loader = $('.jsc-loader-overlay');
    var $elem = $('.jsc-cart-gift-remove');
    $elem.each(function(){
    $loader.show();
    var $key = parseInt($(this).val());

    if ($elem.length > 0) {
        cartJSUpdateQuery($key, 0, {}, true);
    }
    });
}
//End GWP based on cart, product or collection promo
//Start - accordion glossary
opencloseaccordionglossaryonload = () => {
    $(".ingredient-glossary__accordion__trigger").on("click", opencloseaccordionglossary);
}
opencloseaccordionglossary = (evt) => {
    const trigger = $(evt.currentTarget);
    const content = trigger.next(".ingredient-glossary__accordion__content");

    // If this content is already open, close it
    if (content.is(":visible")) {
        content.animate({ height: 0 }, 400, function() {
        $(this).css("display", "none");
        });
    } 
    // Otherwise open it
    else {
        // First, display it but with 0 height
        content.css({
        display: "block",
        height: "0"
        });
        
        // Calculate the final height we want
        const autoHeight = content.prop("scrollHeight");
        
        // Animate to that height
        content.animate({ height: autoHeight }, 400, function() {
        // After animation completes, set to auto to handle content changes
        $(this).css("height", "");
        });
    }
}
replacenoscriptimgglossary = () => {
    // Replace images with noscript content and remove noscript tags
    $(".ingredient-glossary__accordion__content picture").each(function() {
        // Find the noscript element within this picture
        const noscriptContent = $(this).find("noscript").html();
        
        if (noscriptContent) {
        // Replace the placeholder img with the actual image from noscript
        $(this).find("img").replaceWith(noscriptContent);
        
        // Remove the noscript element
        $(this).find("noscript").remove();
        }
    });
}
navigationglossary = () => {
    // When clicking on any letter navigation link (using classes that start with "letter")
    $('a[class^="letter"]').on('click', function(e) {
        e.preventDefault(); // Prevent default anchor behavior
        
        // Get the letter class from the clicked link
        const letterClass = $(this).attr('class');
        
        // Close any open accordions
        $(".ingredient-glossary__accordion__content:visible").each(function() {
            $(this).animate({ height: 0 }, 400, function() {
                $(this).css("display", "none");
            });
        });
        
        // Remove active class from all letter links
        $('a[class^="letter"]').removeClass('active');
        
        // Add active class to clicked letter link
        $(this).addClass('active');
        
        // Remove active class from all glossary letter items
        $('.ingredient-glossary__letters__item').removeClass('active');
        
        // Hide all glossary letter items first
        $('.ingredient-glossary__letters__item').hide();
        
        // Add active class to the corresponding glossary letter item and show it
        console.log(letterClass);
        $('.ingredient-glossary__letters__item.' + letterClass)
            .addClass('active')
            .show();
    });
}
//End - accordion glossary
// Start - description read more function
pdpDescReadMore = () => {
    $('.read-more-link').on('click', function (e) {
        e.preventDefault();

        var $container = $(this).closest('.description-container');
        var $shortDesc = $container.find('.short-description');
        var $fullDesc = $container.find('.full-description');
        var $link = $(this);

        $shortDesc.toggle();
        $fullDesc.toggle();

        if ($fullDesc.is(':visible')) {
        $link.text('View less...');
        } else {
        $link.text('View more...');
        }
    });
}
// End - description view more function

//Start - Anchor button
anchorButton = () => {
    var $target = $('#back-to-top');
    if ($target.length) {
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    }
}
//End - Anchor button

//Start - Loyalty Point Calculation
updateProductPoints = (price) => {
    console.log('updateProductPoints: ', price);
    const currentPrice = price ? parseInt(price, 10) : 0;
    if (currentPrice > 0 && $('.loyalty_point--container .product_point').length > 0) {
        var productPrice = currentPrice / 100;
        var points = Math.floor(productPrice);
        var formatedPrice = theme.Currency.formatMoney(currentPrice, theme.shopSettings.moneyFormat)
        $('.loyalty_point--container .product_point').text(points);
        $('.loyalty_point--container .product-point-conversion').text(formatedPrice);
    }
}
//End - Loyalty Point Calculation

//Start - Get card information max height
getCardInformationMaxHeight = () => {
    // var maxCardTitleHeight = 0;
    var maxCardInfoHeight = 0;
  
    $('.card-information__text, .card-information__wrapper').css('height', 'auto');
  
    // $('.card-information__text').each(function(){
    //   if ($(this).outerHeight() > maxCardTitleHeight) {
    //     maxCardTitleHeight = $(this).outerHeight();
    //   }
    // });
  
    // $('.card-information__text').each(function(){
    //   $(this).height(maxCardTitleHeight);
    // });
  
    $('.card-information__wrapper').each(function(){
      if ($(this).outerHeight() > maxCardInfoHeight) {
        maxCardInfoHeight = $(this).outerHeight();
      }
    });
  
    $('.card-information__wrapper').each(function(){
      $(this).height(maxCardInfoHeight);
    });
  }
//End - Get card information max height
initflickityCarouselGallerycomparison = () =>{
    $('.gallery-comparison-wrap-desktop').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        autoPlay: 3000,
        arrowShape: { 
            x0: 0,
            x1: 40, y1: 40,
            x2: 45, y2: 35,
            x3: 10
          },
        prevNextButtons: true
    });
    $('.gallery-comparison-wrap-mobile').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        autoPlay: 3000,
        arrowShape: { 
            x0: 0,
            x1: 40, y1: 40,
            x2: 45, y2: 35,
            x3: 10
          },
        prevNextButtons: true
    });
}

//Start - Collection tabs & flickity featured collection
handleCollectionTabClick = () => {
    $('.collection-tab').on('click', function(e) {
        e.preventDefault();
        
        $('.collection-tab').removeClass('active');
        $('.tab-panel').removeClass('active');
        
        $(this).addClass('active');
        
        var panelId = $(this).attr('aria-controls');
        
        $('#' + panelId).addClass('active');
        
        // Clean up all Flickity instances
        $('.jsc-flickity-product-grid').each(function() {
            var $grid = $(this);
            try {
                if ($grid.data('flickity')) {
                    $grid.find('.card-wrapper').css('height', 'auto');
                    $grid.flickity('destroy');
                }
            } catch (error) {
                console.log('Error destroying Flickity:', error);
            }
        });
        
        setTimeout(function() {
            initFlickityFeaturedCollection();
        }, 150);
    });
}

initFlickityFeaturedCollection = () => {
    console.log("initFlickityFeaturedCollection");
    
    var $activeGrid = $('.tab-panel.active .jsc-flickity-product-grid');
    
    if ($('.tab-panel.active').length === 0) {
        $activeGrid = $('.jsc-flickity-product-grid');
    }
    
    if ($activeGrid.length > 0) {
        $activeGrid.each(function() {
            var $grid = $(this);
            var itemCount = $grid.find('.grid__item').length;
            var isMobile = window.innerWidth < 750;
            
            try {
                // Destroy existing instance if it exists
                if ($grid.data('flickity')) {
                    $grid.flickity('destroy');
                }
                
                // Reset heights
                $grid.find('.card-wrapper').css('height', 'auto');
                
                // Determine if dragging should be enabled based on item count
                var shouldEnableDragging = isMobile ? itemCount > 2 : itemCount > 4;
                
                var flickityOptions = {
                    cellAlign: 'left',
                    contain: true,
                    pageDots: false,
                    prevNextButtons: false,
                    groupCells: false,
                    wrapAround: shouldEnableDragging, // Only enable wrap around if dragging is enabled
                    autoPlay: false,
                    draggable: shouldEnableDragging, // Disable dragging if not enough items
                    freeScroll: false,
                    cellSelector: '.grid__item',
                    resize: true,
                    imagesLoaded: true,
                    adaptiveHeight: false,
                    on: {
                        ready: function() {
                            try {
                                var $items = $grid.find('.grid__item');
                                var maxHeight = 0;

                                getCardInformationMaxHeight();

                                $items.each(function() {
                                    var height = $(this).find('.card-wrapper').outerHeight();
                                    if (height > maxHeight) maxHeight = height;
                                });
                                $items.each(function() {
                                    $(this).find('.card-wrapper').height(maxHeight);
                                });
                                
                                // Only resize if Flickity is properly initialized
                                if ($grid.data('flickity')) {
                                    $grid.flickity('resize');
                                }

                                // If dragging is disabled, ensure proper grid display
                                if (!shouldEnableDragging) {
                                    $grid.find('.flickity-slider').css({
                                        'transform': 'none',
                                        'display': 'grid',
                                        'grid-template-columns': isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                                        'gap': '1rem'
                                    });
                                }
                            } catch (error) {
                                console.log('Error in Flickity ready callback:', error);
                            }
                        }
                    }
                };
                
                // Initialize Flickity
                $grid.flickity(flickityOptions);
                
                // Ensure Flickity is properly initialized before setting up the resize timeout
                if ($grid.data('flickity')) {
                    setTimeout(function() {
                        try {
                            if ($grid.data('flickity')) {
                                $grid.flickity('resize');
                                
                                // Reapply grid styles if dragging is disabled
                                if (!shouldEnableDragging) {
                                    $grid.find('.flickity-slider').css({
                                        'transform': 'none',
                                        'display': 'grid',
                                        'grid-template-columns': isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
                                        'gap': '1rem'
                                    });
                                }
                            }
                        } catch (error) {
                            console.log('Error in resize timeout:', error);
                        }
                    }, 100);
                }
            } catch (error) {
                console.log('Error initializing Flickity:', error);
            }
        });
    }
}

destroyFlickityFeaturedCollection = () => {
    $('.jsc-flickity-product-grid').each(function() {
        var $grid = $(this);
        try {
            if ($grid.data('flickity')) {
                console.log("destroyFlickityFeaturedCollection");
                $grid.find('.card-wrapper').css('height', 'auto');
                $grid.flickity('destroy');
            }
        } catch (error) {
            console.log('Error in destroyFlickityFeaturedCollection:', error);
        }
    });
}
//End - Collection tabs & flickity featured collection
//Start - Product Tabs choose

clickswapproductabs = (evt,evnt) => {
    const $target = $(evnt.target);
    if ($target.closest('.product-slider-wrap-mobile').length > 0) {
        console.log("Clicked inside .product-slider-wrap-mobile");
        return;
    }
    // Check if the clicked tab is already active
    const wasAlreadyActive = $(evt).hasClass('active');
    
    if (wasAlreadyActive) {
        // If clicked tab is already active, deactivate it
        $(evt).removeClass('active').addClass('deactive');
        
        // Hide all product lists
        $('.product-list-wrap').hide();
        $('.product-list-wrap').removeClass('active');
        
        // Hide product slider or show a default state
        $('.product-slider-wrap').hide();
        
        // No need to run gridflickityproductTabsclick when deactivating
        return;
    }
    
    // First make all tabs inactive
    $(evt).parent().find('.multicolumn-list__item').removeClass('active').addClass('deactive');
    
    // Then make the clicked tab active
    $(evt).addClass('active').removeClass('deactive');
    
    // Get the data-tab attribute value
    var datatab = $(evt).attr('data-tab');
    
    // Hide all product lists
    $('.product-list-wrap').hide();
    $('.product-list-wrap').removeClass('active');
    
    // Show product slider
    $('.product-slider-wrap').show();
    
    // Show and activate the selected product list
    $('.product-list-' + datatab).addClass('active');
    
    // Always run gridflickityproductTabsclick when activating a new tab
    gridflickityproductTabsclick();
}
gridflickityproductTabs = () =>{
    $('.product-grid-flickity').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: false
    });
}
gridflickityproductTabsclick = () =>{
    $('.product-grid-flickity').flickity('destroy');
    $('.product-grid-flickity').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        groupCells: false,
        wrapAround: true,
        draggable: true,
        imagesLoaded: true,
        prevNextButtons: false
    });
}
//End - Product Tabs choose